'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { overlay } from 'overlay-kit';
import type { OfferingItemTypes } from '../_types/offeringTypes';
import OfferingModal from './modal/offering/OfferingModal';
export default function OfferingList() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      name: "contract",
      title: "\uACC4\uC57D\uAD00\uB9AC \uACF5\uBD80 \uC5F0\uB3D9",
      description: "11\uC885 \uACF5\uBD80\uB97C 1\uBD84\uB9CC\uC5D0 \uC5F4\uB78C\uD558\uACE0, \u200B\uACC4\uC57D\uC11C,\n\uD655\uC778\xB7\uC124\uBA85\uC11C\uC5D0 \uC54C\uC544\uC11C \uCC99\uCC99 \uB370\uC774\uD130 \uC790\uB3D9 \uC785\uB825!",
      tabItem: ["\uACF5\uBD80 \uC5F4\uB78C", "\uC790\uB3D9 \uC791\uC131"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "album",
      title: "\uC9D1\uCC0D\uACE0",
      description: "\uCE74\uD1A1, USB \uC62E\uAE30\uAE30 \uC774\uC81C \uADF8\uB9CC\n\uCC0D\uC73C\uBA74 \uC774\uC2E4\uC7A5\uC5D0 \uBC14\uB85C \uC3D9!",
      tabItem: ["\uC0AC\uC9C4 \uC62E\uAE30\uAE30", "\uC0AC\uC9C4 \uD3B8\uC9D1", "\uC0AC\uC9C4 \uC815\uB9AC"]
    };
    t2 = {
      name: "care",
      title: "\uC548\uC2EC\uCF00\uC5B4 \uD504\uB9AC\uBBF8\uC5C4",
      description: "\uBD80\uB3D9\uC0B0 \uAC70\uB798\uC0AC\uACE0 \uAC71\uC815 \uB05D!\n\uB4F1\uAE30\uBCC0\uB3D9\uCCB4\uD06C, \uBC95\uB960\uC0C1\uB2F4, \uAD8C\uB9AC\uBCF4\uD5D8\uAE4C\uC9C0"
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      name: "offerings",
      title: "\uB9E4\uBB3C\uAD11\uACE0",
      description: "\uBB34\uC81C\uD55C \uC6D0\uAC00\uC804\uC1A1, \uBB34\uB8CC \uB85C\uCF13\uB4F1\uB85D\uAE4C\uC9C0 \n\uC5B8\uC81C \uC5B4\uB514\uC11C\uB098 \uD3B8\uB9AC\uD558\uAC8C \uB9E4\uBB3C \uAD00\uB9AC",
      tabItem: ["\uBB34\uC81C\uD55C \uC6D0\uAC00\uC804\uC1A1", "\uB85C\uCF13\uB4F1\uB85D \uBB34\uB8CC"]
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      name: "monitoring",
      title: "\uB9E4\uBB3C\uAD11\uACE0 \uBAA8\uB2C8\uD130\uB9C1",
      description: "\uCC3E\uAE30 \uD798\uB4E0 \uC9C0\uB3C4 \uC18D \uB0B4 \uB9E4\uBB3C\uC744\n\uD3B8\uB9AC\uD558\uAC8C \uBCF4\uACE0 \uB178\uCD9C\uC21C\uC704\uB3C4 \uC27D\uAC8C \uD655\uC778",
      tabItem: ["\uC804\uCCB4\uB9E4\uBB3C\uD604\uD669", "\uB0B4 \uB9E4\uBB3C\uBD84\uC11D"]
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      name: "inspection",
      title: "\uC784\uC7A5 \uB3C4\uC6B0\uBBF8",
      description: "\uC0C8\uB85C\uC6B4 \uAC70\uB798\uB098 \uBCC0\uB3D9\uC0AC\uD56D\uC774 \uC0DD\uAE30\uBA74 \uC989\uC2DC \uC54C\uB824\uC8FC\uACE0 \n\uC810\uC720\uD615\uD0DC, \uB4F1\uAE30\uC815\uBCF4 \uB4F1 \uC784\uC7A5\uD65C\uB3D9 \uC9C0\uC6D0",
      tabItem: ["\uC784\uC7A5\uD65C\uB3D9 \uC9C0\uC6D0", "\uBCC0\uB3D9\uC0AC\uD56D \uC54C\uB9BC"]
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [t0, t1, t2, t3, t4, t5, {
      name: "property",
      title: "\uB514\uC9C0\uD138 \uB9E4\uBB3C\uC7A5",
      description: "\uACE0\uAC1D&\uBB3C\uAC74 \uC815\uBCF4 \uD1B5\uD569 \uAD00\uB9AC\n\uACE0\uAC1D\uC758 \uC870\uAC74\uC5D0 \uB9DE\uB294 \uB9E4\uBB3C \uCD94\uCC9C\uBC1B\uAE30",
      tabItem: ["\uACE0\uAC1D \uAD00\uB9AC", "\uB9E4\uBB3C \uCC3E\uAE30", "\uB9E4\uBB3C \uCD94\uCC9C"]
    }];
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const services = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ul className="wrap_card">{services.map(_temp)}</ul>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}
function _temp(service) {
  return <OfferingItem key={service.name} name={service.name} title={service.title} description={service.description} tabItem={service.tabItem} />;
}
export function OfferingItem(t0) {
  const $ = _c(20);
  const {
    name,
    title,
    description,
    tabItem
  } = t0;
  let t1;
  if ($[0] !== tabItem || $[1] !== title) {
    t1 = name_0 => {
      overlay.open(t2 => {
        const {
          isOpen,
          close
        } = t2;
        return <OfferingModal isOpen={isOpen} close={close} name={name_0} title={title} tabItem={tabItem} />;
      });
    };
    $[0] = tabItem;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onClickPopup = t1;
  let t2;
  if ($[3] !== name) {
    t2 = clsx("card", name);
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name || $[6] !== onClickPopup) {
    t3 = () => onClickPopup(name);
    $[5] = name;
    $[6] = onClickPopup;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <h2 className="title">{title}</h2>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== description) {
    t5 = <p className="desc">{description}</p>;
    $[10] = description;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="btn_line_gray300">자세히보기<i className="icon_angle" /></span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t7 = <button type="button" onClick={t3}>{t4}{t5}{t6}</button>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t7) {
    t8 = <li className={t2}>{t7}</li>;
    $[17] = t2;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}